export const signUpContactEvent = () => {
  window.fbq('track', 'Contact');
};
